import { useEffect, useRef, useState } from 'react';

function FAQ() {
  const faqs = [
    { question: 'Как подключиться к сервису?', answer: 'Для подключения к сервису перейдите в Telegram-бот @ProtocolGOIDA и следуйте инструкциям. Процесс займет не более 2 минут.' },
    { question: 'Какие устройства поддерживаются?', answer: 'Поддерживаются Windows, macOS, Linux, Android / TV, iOS.' },
    { question: 'Безопасен ли трафик?', answer: 'Трафик шифруется протоколом VLESS Reality и не сохраняется на серверах (политика no-logs).' },
    { question: 'Как оплатить подписку?', answer: 'Оплата производится через Telegram-бота любым удобным способом: карты, криптовалюта, электронные кошельки.' },
    { question: 'Что делать, если не работает YouTube AdBlock?', answer: 'Проверить выбранный регион с поддержкой AdBlock. При сохранении проблемы обратиться в поддержку.' },
    { question: 'Как работает реферальная система?', answer: 'Предоставляется бонус за каждого приглашённого пользователя, пополнившего баланс.' },
    { question: 'Можно ли использовать сервис для торрентов?', answer: 'Использование BitTorrent и других P2P-протоколов запрещено и может привести к блокировке доступа.' },
    { question: 'Что такое «Мультиаккаунт»?', answer: 'Возможность передавать свой аккаунт другому пользователю.' },
  ];

  const [openIndex, setOpenIndex] = useState(null);
  const answerRefs = useRef([]);

  const toggleItem = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const setAnswerRef = (el, index) => {
    answerRefs.current[index] = el;
  };

  useEffect(() => {
    // После изменения openIndex обновляем высоты
    answerRefs.current.forEach((el, idx) => {
      if (!el) return;
      const isOpen = openIndex === idx;
      // Сначала сбрасываем инлайн-стили, чтобы получить корректный scrollHeight
      el.style.transition = 'none';
      if (isOpen) {
        el.style.height = 'auto';
        const target = el.scrollHeight;
        el.style.height = '0px';
        // Принудительный рефлоу
        void el.offsetHeight;
        el.style.transition = '';
        el.style.height = `${target}px`;
        // После завершения анимации фиксируем на auto
        const onEnd = (e) => {
          if (e.propertyName === 'height') {
            el.style.height = 'auto';
            el.removeEventListener('transitionend', onEnd);
          }
        };
        el.addEventListener('transitionend', onEnd);
      } else {
        // Закрытие: с auto до 0
        const current = el.scrollHeight;
        el.style.height = `${current}px`;
        // Принудительный рефлоу
        void el.offsetHeight;
        el.style.transition = '';
        el.style.height = '0px';
      }
    });
  }, [openIndex]);

  return (
    <section className="faq-bg">
      <div className="faq-section page-pad">
        <h2 className="faq-title">Вопросы и ответы</h2>
        <div className="faq-list">
          {faqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div
                key={index}
                className={`faq-item${open ? ' open' : ''}`}
                onClick={() => toggleItem(index)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleItem(index);
                  }
                }}
                aria-expanded={open}
              >
                <button className="faq-question" type="button">
                  <span className="faq-question-text">{faq.question}</span>
                  <svg className="faq-arrow" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 9l6 6 6-6" stroke="#D68027" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </button>
                <div className="faq-answer" ref={(el) => setAnswerRef(el, index)}>{faq.answer}</div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

export default FAQ;
